module.exports = __webpack_public_path__ + "static/thumbnail-345d776027c42c98e57046c19d26009a.png";